import { Nobles } from '../../lib/anuket';
import { connectStream } from '../../lib/bastetjs/utils/connectStream';
import React from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { Link } from 'react-router-dom';

import { styles } from './styles';
import { getResultsUrl } from '../../utils/resultsHelpers';
import { colors } from '../../shared/styles';
import { assign, flow, map, times } from 'lodash';
import moment from 'moment';
import { trackGoogleEvent } from '../../utils/googleEvents';

export const ElpResultsComponent = (props) => {
  const {
    t,
    isMobile
  } = props;

  const RACE_DATE_DISPLAY_THRESHOLD = isMobile ? 4 : 12;

  const { athlinksMasterId } = props.event;

  const {
    dates = [],
    isLoading
  } = props.result;

  if (dates.length < 1 && !isLoading) {
    return (<div/>);
  }

  const revealHiddenRaceDates = () =>
    map(document.getElementsByClassName('race-date'),
        (raceDate) =>  {
          raceDate.style['display'] = 'block';
        })

  const addOpacityToInvisibleDateCells = () =>
    map(document.getElementsByClassName('invisible-race-date'),
        (invisibleRaceDate) =>  {
          invisibleRaceDate.style['opacity'] = 0;
          invisibleRaceDate.style['display'] = 'flex';
        })

  const showAddMissingResults = () =>  {
    document.getElementById('add-missing-results')
      .style['display'] = 'flex';
    return null;
  }

  const hideSeeMore = (e) =>  {
    e.preventDefault();
    document.getElementById('div-see-more').style['display'] = 'none'
  };

  const showAllRaceDates =
    flow(
      hideSeeMore,
      addOpacityToInvisibleDateCells,
      revealHiddenRaceDates,
      showAddMissingResults
    );

  const changeColors = (color, backgroundColor) =>  (id) =>  () =>  {
    const element = document.getElementById(id);
    if(element) {
      element.style['color'] = color;
      element.style['background-color'] = backgroundColor;
    }
  };

  const applyHoverColors =
    changeColors(
      styles.flexColStyle(isMobile).hoverColor,
      styles.flexColStyle(isMobile).hoverBackgroundColor
    );

  const applyColors =
    changeColors(
      styles.flexColStyle(isMobile).color,
      styles.flexColStyle(isMobile).backgroundColor
    );

  const invisibleDateCell = (prefix) => (hidden) => (id) => (
    <div
      id={`invisible-date-cell-${prefix}-${id}`}
      key={`invisible-date-cell-${prefix}-${id}`}
      className='invisible-race-date'
      style={
        assign(
          styles.flexColStyle(isMobile),
          hidden ? {
              display: 'none'
            } : {
              opacity: 0
            }
        )
      }/>
  );

  const showSeeMore = () => (
    <div
      id={'div-see-more'}
      style={
        assign(
          styles.flexColStyle(isMobile),
          isMobile ?
            {
              border: '0px',
              flex: '0 0 100%'
            } :  {}
          )
      }>
      <Link
        id='div-see-more-link'
        to="#"
        onClick={showAllRaceDates}
        onMouseOver={applyHoverColors('div-see-more-link')}
        onMouseOut={applyColors('div-see-more-link')}
        style={{
          ...assign(
            {},
            styles.link,
            isMobile ? {
              color: colors.blue,
              textTransform: 'capitalize'
            } : {}
          )}}>
            {t(isMobile ? 'Show All...' : 'see more ...')}
      </Link>
    </div>
  );

  const getLink = (eventId, linkText, idx, masterId, display = true) => (
    <div key={`div-${idx || 0}`}
         style={styles.flexColStyle(isMobile, display)}
         className="race-date">
      <Link
        id={`div-race-date-link-${idx || 0}`}
        onMouseOver={ applyHoverColors(`div-race-date-link-${idx || 0}`) }
        onMouseOut={ applyColors(`div-race-date-link-${idx || 0}`) }
        onClick={ () => trackGoogleEvent('ELP', 'Click', 'getRaceDateResults') }
        to={{pathname: getResultsUrl(masterId, eventId)}}
        key={idx || 0}
        style={styles.link}
        className={'results-year-links'}>
        {linkText}
      </Link>
    </div>
  );

  const lessThan = (x) => (y) => y<x;
  const equalOrGreaterThan = (x) => (y) => y>=x;
  const lessThanRaceDateThreshold = lessThan(RACE_DATE_DISPLAY_THRESHOLD);
  const equalOrGreaterThanRaceDateThreshold = equalOrGreaterThan(RACE_DATE_DISPLAY_THRESHOLD);
  const applyPredicate = (predicate) => (value) => predicate(value);
  const isLessThanRaceDateThreshold = applyPredicate(lessThanRaceDateThreshold);
  const isAtOrBeyondRaceDateThreshold = applyPredicate(equalOrGreaterThanRaceDateThreshold);
  const numberOfDateColumns = isMobile ? 3 : 2
  const paddingSize = (size) => {
    const remainingCols = size % numberOfDateColumns;
    return (remainingCols && (remainingCols < numberOfDateColumns)) ?
      numberOfDateColumns - remainingCols
      : 0;
  }

  const invisibleCellsBeforeSeeMore = invisibleDateCell('before-see-more')(false);
  const invisibleCellsAfterSeeMore = invisibleDateCell('after-see-more')(true);

  return (
    <div style={styles.container}>
      <div style={styles.title}>
        {t('Results')}
        <div style={styles.loadingTitle(isLoading)}/>
      </div>
      <div>
        <div id='race-date-container' style={styles.flexStyle}>
          {
            dates.map((_, raceDateIndex) =>
              getLink(
                _.eventId,
                moment(_.date).format('MMM DD, YYYY'),
                raceDateIndex,
                athlinksMasterId,
                isLessThanRaceDateThreshold(raceDateIndex + 1)
              ))
          }
          {
            isLessThanRaceDateThreshold(dates.length) &&
              times(
                paddingSize(dates.length),
                (id) => invisibleCellsBeforeSeeMore(id))
          }
          {
            (dates.length >= RACE_DATE_DISPLAY_THRESHOLD) ?
              showSeeMore() :
              !isLoading && showAddMissingResults()
          }
          {
            isAtOrBeyondRaceDateThreshold(dates.length) &&
              times(
                paddingSize(dates.length),
                (id) => invisibleCellsAfterSeeMore(id))
          }
        </div>
      </div>
    </div>
  );
};

ElpResultsComponent.propTypes = {
  result: PropTypes.object,
  event: PropTypes.object, //needed by connectStream to re-render on changing event
  t: PropTypes.func
};

ElpResultsComponent.defaultProps = {
  result: { years: [], isLoading: true }
};

export const ElpResults = withTranslation()(connectStream({
  result: ({event}) => {
    return Nobles.ResultsNoble.getEventRaceDates({
      eventId: event.athlinksId
    });
  }
})(ElpResultsComponent));
